import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';
import { Logo } from '../components/Brand';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className='min-h-screen flex items-center justify-center bg-[#FFF8F2] p-6'>
      <Card className='w-full max-w-lg p-8 shadow-xl border border-slate-200 text-center'>
        <div className='flex justify-center mb-4'><Logo /></div>
        <XCircle className='w-14 h-14 text-[#B45309] mx-auto' />
        <h2 className='font-display text-2xl font-bold mt-4'>Payment canceled</h2>
        <p className='text-slate-600 mt-2'>Your booking is still on hold. Try paying again or pick a different time.</p>
        <div className='mt-6 flex justify-center gap-2'>
          <Button variant='outline' onClick={() => navigate('/client/bookings')}>My Bookings</Button>
          <Button className='bg-[#1B3A87] hover:bg-[#16306F] text-white' onClick={() => navigate('/client/book')}>Try again</Button>
        </div>
      </Card>
    </div>
  );
}
